<template>
  <div class="container columns flex">
    <component
      :is="block.component"
      v-for="block in blocks"
      :key="block._uid"
      :blok="block"
    />
  </div>
</template>

<script setup lang="ts">
import type { BlockColumnsStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockColumnsStoryblok
}>()
const { blocks } = useStoryContent(toRefs(props))
</script>

<style lang="less" scoped>
.columns {
  flex-direction: column;

  @media @tablet {
    .justify-between();

    gap: @8px;
    flex-direction: row;
  }
}
</style>
